import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  isShowModalConfirm: false, // 是否展示modalConfirm
  onCancel: null,
  onSubmit: null,
  cancelText: '',
  submitText: '',
  cancelType: '',
  submitDanger: '',
  headerText: '',
  bodyText: '',
  isDistinguishCancel: false,
  onClickOther: null,
  hasCancel: true,
  isShowDropboxModal: false,
  isShowDropboxSuccessModal: false,
  isShowLoadingModal: false, // 是否展示loading modal
  isShowRecordingModal: false, // 是否显示预览video弹窗
  isShowScreenRecordingTimingModal: false, // 是否显示录屏计时弹窗
  isShowTextEditorModal: false, // 是否显示编辑文字的弹窗
  isShowRelinkModal: false, // 是否relink的弹窗
  isShowRecordFromModal: false, // 录制入口的弹窗
  isShowQuickGuideModal: false, // 是否显示 Welcome, View FlexClip Pro 30 seconds quick guide
  isShowUnsupportSafariModal: false, // 是否现在不支持safari的弹窗,
	isShowStockVideoModal: false,
	isShowStockDetailsModal: false,
	stockDetailData: '',
  dropBoxShareUrl: '',
  isShowCloudBenefitModal: false,
  hasNoShowAgain: false
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SHOW_CONFIRM_MODAL: {
      return {
        ...state,
        isShowModalConfirm: true,
        hasNoShowAgain: false,
        ...action.data
      };
    }
    case FJActionConstant.HIDE_CONFIRM_MODAL: {
      return {
        ...state,
        isShowModalConfirm: false,
        onSubmit:null,
      };
    }
    case FJActionConstant.INIT_CONFIRM_MODAL_DATA: {
      return {
        ...state,
        onCancel: null,
        onSubmit: null,
        cancelText: '',
        submitText: '',
        cancelType: '',
        submitDanger: '',
        headerText: '',
        bodyText: '',
        hasCancel: true,
        isDistinguishCancel: false,
        onClickOther: null
      };
    }
    case FJActionConstant.SET_IS_SHOW_LOADING_MODAL: {
      return {
        ...state,
        isShowLoadingModal: action.data,
      };
    }
    case FJActionConstant.SET_IS_SHOW_RECORDING_MODAL:
      return {
        ...state,
        isShowRecordingModal: action.data
      };
    case FJActionConstant.SET_IS_SHOW_SCREEN_RECORDING_MODAL:
      return {
        ...state,
        isShowScreenRecordingTimingModal: action.data
      };
    case FJActionConstant.SET_IS_SHOW_TEXT_EDITOR_MODAL:
      return {
        ...state,
        isShowTextEditorModal: action.data
      };
    case FJActionConstant.SET_IS_SHOW_RELINK_MODAL:
      return {
        ...state,
        isShowRelinkModal: action.data
      };
    case FJActionConstant.SET_IS_SHOW_RECORD_FROM_MODAL:
      return {
        ...state,
        isShowRecordFromModal: action.data
      };
    case FJActionConstant.SET_IS_SHOW_QUICK_GUIDE_MODAL:
      return {
        ...state,
        isShowQuickGuideModal: action.data
      };
    case FJActionConstant.SET_IS_SHOW_UNSUPPORT_SAFARI_MODAL:
      return {
        ...state,
        isShowUnsupportSafariModal: action.isShow
      };
		case FJActionConstant.SET_IS_SHOW_STOCK_VIDEO_MODAL:
			return {
				...state,
				isShowStockVideoModal: action.data
			}
		case FJActionConstant.SHOW_STOCK_DETAILS_MODAL:
			return {
				...state,
				isShowStockDetailsModal: true,
				stockDetailData: action.data
			}
		case FJActionConstant.HIDE_STOCK_DETAILS_MODAL:
			return {
				...state,
				isShowStockDetailsModal: false,
				stockDetailData: action.data
			}
    case FJActionConstant.SET_IS_SHOW_DROPBOX_MODAL:
      return {
        ...state,
        isShowDropboxModal: action.data,
      }
    case FJActionConstant.SET_IS_SHOW_DROPBOX_SUCCESS_MODAL:
      return {
        ...state,
        isShowDropboxSuccessModal: action.data,
        dropBoxShareUrl: action.shareUrl,
      }
    case FJActionConstant.SET_IS_SHOW_CLOUD_BENEFIT_MODAL: {
      return {
        ...state,
        isShowCloudBenefitModal: action.data,
      }
    }
    default:
      return state;
  }
}
